var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.98926C16.7956 4.98926 17.5587 5.30533 18.1213 5.86794C18.6839 6.43055 19 7.19361 19 7.98926C19 8.78491 18.6839 9.54797 18.1213 10.1106C17.5587 10.6732 16.7956 10.9893 16 10.9893M8 4.98926V15.9893C8 16.2545 7.89464 16.5088 7.70711 16.6964C7.51957 16.8839 7.26522 16.9893 7 16.9893H6C5.73478 16.9893 5.48043 16.8839 5.29289 16.6964C5.10536 16.5088 5 16.2545 5 15.9893V10.9893",
    stroke: "#8B909A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.98921L14.524 1.21921C14.6555 1.10971 14.8154 1.03996 14.9851 1.01811C15.1548 0.996264 15.3271 1.02323 15.482 1.09586C15.6369 1.16848 15.7679 1.28375 15.8597 1.42816C15.9514 1.57256 16.0001 1.74012 16 1.91121V14.0672C16.0001 14.2383 15.9514 14.4058 15.8597 14.5503C15.7679 14.6947 15.6369 14.8099 15.482 14.8826C15.3271 14.9552 15.1548 14.9821 14.9851 14.9603C14.8154 14.9385 14.6555 14.8687 14.524 14.7592L10 10.9892H2C1.73478 10.9892 1.48043 10.8838 1.29289 10.6963C1.10536 10.5088 1 10.2544 1 9.98921V5.98921C1 5.72399 1.10536 5.46964 1.29289 5.2821C1.48043 5.09456 1.73478 4.98921 2 4.98921H10Z",
    stroke: "#8B909A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncements);
export default __webpack_public_path__ + "static/media/Announcements.b92b088adef73585d8b89525bf5ea76e.svg";
export { ForwardRef as ReactComponent };